// TODO(Joshua Harris, Luis Sardon): improve theme resolver approach
import { colorMap, SecondaryColors, Theme } from '@/utils/constants';

const resolveTheme =
  (base: 'text-color' | 'bg-color') =>
  ({ rawVal }: any) => {
    const color = rawVal?.toLowerCase();
    const isLight =
      !color ||
      color === Theme.light ||
      color === colorMap.eggshell ||
      color === colorMap.white ||
      color === SecondaryColors.main ||
      /^eggshell$/i.test(color) ||
      /^white$/i.test(color) ||
      /^blue$/i.test(color);

    if (/text-color/i.test(base)) {
      return isLight ? Theme.dark : Theme.light;
    }

    return isLight ? Theme.light : Theme.dark;
  };

export default resolveTheme;
